// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 993) return "static/chunks/993.1dad47de31ae0c1a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"286":"cfda0e5def00417e","909":"61f982b5118bbb25","980":"f49825db6588100f"}[chunkId] + ".js";
};